// extracted by mini-css-extract-plugin
export default {"root":"WatchlistsEmpty_root__kVHIJ","animation":"WatchlistsEmpty_animation__1zTIZ","button":"WatchlistsEmpty_button__4pI8h"};